export default __webpack_public_path__ + "static/media/icon_birthday.f2d059cd.svg";